import { FunctionComponent, ReactElement } from 'react';

import { formatDistributedForce, formatForce } from '@paragon/client-tools';
import { Load } from '@paragon/contract-library';
import { Direction2D } from '@paragon/geometry-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { prepareLoadForDrawing } from '../../../../../library/loadProjectionUtilities';
import { getDistanceFormatterSelector } from '../../../../../store/selectors/getDistanceFormatterSelector';
import { useAppSelector } from '../../../../hooks';
import { DisplayNameProviderProps } from './PrimaryRowText';

export const LoadName: FunctionComponent<DisplayNameProviderProps<Load>> = (props) => {
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  const showLoadsUnprojected = useAppSelector((state) => state.visualOptions.showLoadsUnprojected);

  const { load } = prepareLoadForDrawing(showLoadsUnprojected)(props.row.item);
  const manualLoadIndicator = load.isManualLoad ? '* ' : '';
  switch (load.distribution) {
    case 'Concentrated':
      // @ts-expect-error https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/53846
      return `${manualLoadIndicator}${distanceFormatter(load.start.x)} (${formatForce(
        load.startMagnitude,
      )})` as ReactElement;
    case 'Distributed':
      const isSidewaysNonDragLoad =
        Direction2D.fromObject(load.direction).isParallelTo(Direction2D.right) && load.loadType !== 'Drag';
      const loadStart = isSidewaysNonDragLoad ? load.start.y : load.start.x;
      const loadEnd = isSidewaysNonDragLoad ? load.end.y : load.end.x;
      // @ts-expect-error https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/53846
      return `${manualLoadIndicator}${distanceFormatter(loadStart)} - ${distanceFormatter(
        loadEnd,
      )} (${formatDistributedForce(load.startMagnitude)} - ${formatDistributedForce(
        load.endMagnitude,
      )})` as ReactElement;
    default:
      assertExhaustiveSwitch(load, 'Unrecognized load distribution.');
  }
};
